module.exports = __webpack_public_path__ + "background24.jpg?0a0f7248e4be6103c3ceb1d6591d76d6";